import { AppPermissions } from "../constants/appPermissions.js";
export class ReportPolicy {
    user;
    constructor(container) {
        this.user = container.user;
    }
    allowsViewReport(report) {
        if (!this.user) {
            return false;
        }
        if (this.user.isAdmin) {
            return true;
        }
        if (report.isPrivate) {
            return this.user.hasPermission(AppPermissions["View Private Reports"]);
        }
        else {
            return true;
        }
    }
    allowsViewDraft(report) {
        if (!this.user) {
            return false;
        }
        if (this.user.isAdmin) {
            return true;
        }
        return report.createdById === this.user.id;
    }
    allowsEditDraft(report) {
        if (!this.user) {
            return false;
        }
        if (this.user.isAdmin) {
            return true;
        }
        return report.createdById === this.user.id;
    }
    allowsEditReport(report) {
        if (!this.user) {
            return false;
        }
        if (this.user.isAdmin) {
            return true;
        }
        const havePermissionToUpdateReport = this.user.hasPermission(AppPermissions["Update Report"]);
        const canViewPrivateReports = this.user.hasPermission(AppPermissions["View Private Reports"]);
        if (!havePermissionToUpdateReport) {
            return false;
        }
        if (report.isPrivate) {
            return canViewPrivateReports;
        }
        else {
            return true;
        }
    }
    allowsAddReportRemark(report) {
        if (!this.user) {
            return false;
        }
        if (this.user.isAdmin) {
            return true;
        }
        const havePermissionToAddRemarks = this.user.hasPermission(AppPermissions["Add Report Remarks"]);
        const canViewPrivateReports = this.user.hasPermission(AppPermissions["View Private Reports"]);
        if (!havePermissionToAddRemarks) {
            return false;
        }
        if (report.isPrivate) {
            return canViewPrivateReports;
        }
        else {
            return true;
        }
    }
    allowsDeleteReport(report) {
        if (!this.user) {
            return false;
        }
        if (this.user.isAdmin) {
            return true;
        }
        const havePermissionToDeleteReport = this.user.hasPermission(AppPermissions["Delete Report"]);
        const canViewPrivateReports = this.user.hasPermission(AppPermissions["View Private Reports"]);
        if (!havePermissionToDeleteReport) {
            return false;
        }
        if (report.isPrivate) {
            return canViewPrivateReports;
        }
        else {
            return true;
        }
    }
    allowsEscalateReport(report) {
        if (!this.user) {
            return false;
        }
        if (this.user.isAdmin) {
            return true;
        }
        const havePermissionToEscalateReport = this.user.hasPermission(AppPermissions["Esclate Report"]);
        const canViewPrivateReports = this.user.hasPermission(AppPermissions["View Private Reports"]);
        if (!havePermissionToEscalateReport) {
            return false;
        }
        if (report.isPrivate) {
            return canViewPrivateReports;
        }
        else {
            return true;
        }
    }
    allowsDownloadReportAsPdf(report) {
        if (!this.user) {
            return false;
        }
        if (this.user.isAdmin) {
            return true;
        }
        const havePermissionToDownloadReportAsPdf = this.user.hasPermission(AppPermissions["Download Report as Pdf"]);
        const canViewPrivateReports = this.user.hasPermission(AppPermissions["View Private Reports"]);
        if (!havePermissionToDownloadReportAsPdf) {
            return false;
        }
        if (report.isPrivate) {
            return canViewPrivateReports;
        }
        else {
            return true;
        }
    }
    allowsShareReport(report) {
        if (!this.user) {
            return false;
        }
        if (this.user.isAdmin) {
            return true;
        }
        const havePermissionToShareReport = this.user.hasPermission(AppPermissions["Share Report"]);
        const canViewPrivateReports = this.user.hasPermission(AppPermissions["View Private Reports"]);
        if (!havePermissionToShareReport) {
            return false;
        }
        if (report.isPrivate) {
            return canViewPrivateReports;
        }
        else {
            return true;
        }
    }
}
//# sourceMappingURL=ReportPolicy.js.map